import { forwardRef, PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';

import Button, { ButtonProps } from '../button/button';

/**
 * Custom button which combines react-hook-form & button
 */
export const FormCancelButton = forwardRef<HTMLButtonElement, PropsWithChildren<ButtonProps>>((props, ref) => {
  const { className, children, color = 'secondary-light', disabled, ref: _buttonRef, ...buttonProps } = props;

  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Button
      className={className}
      ref={ref}
      color={color}
      disabled={disabled || isSubmitting}
      {...buttonProps}
    >
      {children}
    </Button>
  );
});

export default FormCancelButton;
